export default __webpack_public_path__ + "static/media/profile.915c60dc.jpg";